import React from "react"
import {ErrorDocument} from "../../resources/common"
import {AsyncResultIdleRequestState} from "../../types/asyncResultIdle"
import {refreshAndClose} from "../../utilities/modals"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"

interface CompletePendingProps<T> {
	title: string
	close: () => void
	onSuccess: () => void
	state: AsyncResultIdleRequestState<T, ErrorDocument>
	completePendingFn: () => void
}

export function CompletePendingModal<T>({title, close, onSuccess, state, completePendingFn}: CompletePendingProps<T>) {
	return (
		<AsyncResultModal
			title={title}
			close={refreshAndClose(onSuccess, close)}
			buttonClassname="is-black"
			state={state}
			buttonText="Confirm"
			successText="Completed"
			onSubmit={completePendingFn}
			errorToText={(_) => "Error completing pending application"}
		>
			<p>Are you sure you want to trigger a manual attempt to complete the pending application?</p>
		</AsyncResultModal>
	)
}
